import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8y38abnnmk: FaireBrandEntity = {
  token: "b_8y38abnnmk",
  type: "brand",
  name: "Yawoo Garments",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c08c52c40ab4a2871d0b2382a4bd94a3d9d0da4b5a622e023b3d83a6c4a7101.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/544d716a8019b3fddc90cf09bb1927c1db9974b8c15699eaf71fa2546963b7b8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c08c52c40ab4a2871d0b2382a4bd94a3d9d0da4b5a622e023b3d83a6c4a7101.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/544d716a8019b3fddc90cf09bb1927c1db9974b8c15699eaf71fa2546963b7b8.jpeg",
  location: "Plano, TX, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 1026,
  isInsider: false,
  description:
    "The shipping company will have the holiday from Feb 11st till Feb 24th,It's better to order before Feb 9th if need to be shipped out before the holiday. No import duties, We will ship order by express. Order $100-$1999  shipping fee is 25% item subtotal. Order more than $2000 shipping fee is 20% item subtotal.  We have a 12 years history in producing and selling baby kids clothing. We mainly do girls outfits, girls dresses, baby romper, boy outfits ,shirts,denim clothing,backpack etc. We have our own factory and warehouse, can produce about 10000 pcs clothing per day. Reasonable price,fashion designs,High quality are our advantages.we will update new styles everyday.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:00.420Z",
    importedBy: "entity-db-cli",
  },
};
